import { inject, Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { ThemeService } from '@wind-log_library/fe-component-library';
@Pipe({ name: 'iconsPipe', standalone: true })
export class IconsPipe implements PipeTransform {
  private themeService = inject(ThemeService);
  private iconList = [
    {
      key: 'icon-portfolio',
      light: {
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-portfolio-light.svg`,
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-portfolio-light.svg`,
      },
      dark: {
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-portfolio-dark.svg`,
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-portfolio-dark.svg`,
      },
    },
    {
      key: 'icon-country',
      light: {
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-country-light.svg`,
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-country-light.svg`,
      },
      dark: {
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-country-dark.svg`,
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-country-dark.svg`,
      },
    },
    {
      key: 'icon-monitor',
      light: {
        active: `${environment.shared_server}/general/module-icons/icon-monitor-light.svg`,
        basic: `${environment.shared_server}/general/module-icons/icon-monitor-light.svg`,
      },
      dark: {
        active: `${environment.shared_server}/general/module-icons/icon-monitor-dark.svg`,
        basic: `${environment.shared_server}/general/module-icons/icon-monitor-dark.svg`,
      },
    },
    {
      key: 'site-navigation',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-site-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-site-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-site-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-site-light.svg`,
      },
    },
    {
      key: 'mast',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-mast-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-mast-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-mast-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-mast-light.svg`,
      },
    },
    {
      key: 'lidar',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-lidar-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-lidar-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-lidar-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-lidar-light.svg`,
      },
    },
    {
      key: 'reference',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-reference-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-reference-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-reference-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-reference-light.svg`,
      },
    },
    {
      key: 'sodar',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-light.svg`,
      },
    },
    {
      key: 'radar',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-sodar-light.svg`,
      },
    },
    {
      key: 'solar',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-solar-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-solar-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-solar-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-solar-light.svg`,
      },
    },
    {
      key: 'offshorebuoy',
      dark: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-offshore-buoy-dark.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-offshore-buoy-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/resource-panorama/icon-offshore-buoy-light.svg`,
        active: `${environment.shared_server}/general/nav/resource-panorama/icon-offshore-buoy-light.svg`,
      },
    },
    {
      key: 'load-navigation',
      dark: {
        basic: `${environment.shared_server}/general/nav/icon-load-dark.svg`,
        active: `${environment.shared_server}/general/nav/icon-load-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/nav/icon-load-light.svg`,
        active: `${environment.shared_server}/general/nav/icon-load-light.svg`,
      },
    },
    {
      key: 'filter',
      dark: {
        basic: `${environment.shared_server}/general/main-interface/icon-filter-dark.svg`,
        active: `${environment.shared_server}/general/main-interface/icon-filter-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/main-interface/icon-filter-light.svg`,
        active: `${environment.shared_server}/general/main-interface/icon-filter-light.svg`,
      },
    },
    {
      key: 'chevron-down',
      dark: {
        basic: `${environment.shared_server}/general/main-interface/icon-chevron-down.svg`,
        active: `${environment.shared_server}/general/main-interface/icon-chevron-down.svg`,
      },
      light: {
        basic: `${environment.shared_server}/general/main-interface/icon-chevron-down.svg`,
        active: `${environment.shared_server}/general/main-interface/icon-chevron-down.svg`,
      },
    },
    {
      key: 'solar-navigation',
      dark: {
        basic: `${environment.shared_server}/sun-log/nav/icon-solarplant-dark.svg`,
        active: `${environment.shared_server}/sun-log/nav/icon-solarplant-dark.svg`,
      },
      light: {
        basic: `${environment.shared_server}/sun-log/nav/icon-solarplant-light.svg`,
        active: `${environment.shared_server}/sun-log/nav/icon-solarplant-light.svg`,
      },
    },
    {
      key: 'uploadIcon',
      dark: {
        basic: `../../../../../assets/images/buttons/UploadIcon-White.svg`,
        active: `../../../../../assets/images/buttons/UploadIcon-White.svg`,
      },
      light: {
        basic: `../../../../../assets/images/buttons/UploadIcon-DarkBlue.svg`,
        active: `../../../../../assets/images/buttons/UploadIcon-DarkBlue.svg`,
      },
    },
  ];

  transform(value: any, active?: boolean, hover?: boolean): any {
    return this.themeService.getTheme().pipe(
      map(name => {
        const icon: any = this.iconList.find(i => i.key === value);
        const srcKey = hover && !active ? 'hover' : active ? 'active' : 'basic';
        return icon ? icon[name][srcKey] : '';
      }),
    );
  }
}
